import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Select } from '@chakra-ui/react';
import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { CHANNELS, CHANNEL_LABELS } from 'types/customer';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 契約種別のフォームのベースです。
 * NOTE: Chakra の Select は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const ChannelFormBase: FC<Props> = ({ register }) => (
  <Select
    {...register('channel', {
      required: '必須項目です。',
    })}
    // TODO: beta 運用が始まるまでは、契約種別を stable 以外選択できないようにしています。
    // beta 運用が始まったら disabled を削除してください。
    disabled
  >
    <option value={CHANNELS.STABLE}>{CHANNEL_LABELS[CHANNELS.STABLE]}</option>
    <option value={CHANNELS.BETA}> {CHANNEL_LABELS[CHANNELS.BETA]}</option>
  </Select>
);
